<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">{{'global.menu.home' | translate}}</a></li>
      <li><a href="">{{'global.menu.accountt' | translate}}</a></li>
      <li class="active">{{'global.form.changepassword' | translate}}</li>
    </ol>
  </div>
  <div class="col-md-12">
    <h2 class="changePasswordHeading">{{'global.form.changepassword' | translate}}</h2>
  </div>
  <div class="col-md-12 mainPasswordDiv">
    <div class="alert alert-success centerText" *ngIf="success">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>{{'password.messages.success' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error">
      <strong>{{'password.messages.error' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRCP000001">
      <strong>{{'password.messages.ERRCP000001' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRCP000002">
      <strong>{{'password.messages.ERRCP000002' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRCP000003">
      <strong>{{'password.messages.ERRCP000003' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRCP000004">
      <strong>{{'password.messages.ERRCP000004' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRCP000005">
      <strong>{{'password.messages.ERRCP000005' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="doNotMatch">
      <strong>{{'password.messages.dontmatch' | translate}}</strong>
    </div>
    <form #passwordForm="ngForm" name="form"  (submit)="changePassword()" >
      <div class="col-md-4 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="password"  id="currentpassword" (change)="updateCurrentPassLabelStyle()"
                 ngControl="currentPasswordCtrl" name="currentPassword" [(ngModel)]="currentPassword"
                 autocomplete="off" autofocus required>
          <span class="bar"></span>
          <label [ngClass]="[updateCurrentPass ? 'customLabel' : '']">{{'global.form.currentpassword' | translate}}</label>
        </div>
      </div>
      <div class="col-md-4 noPaddingMd-12">
      <div class="login-form-group pmi_form_group">
        <input type="password"  id="password"
               name="newPassword" [(ngModel)]="newPasswordVal" (change)="updateLabelStyle()"
               pattern="^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
               minlength=4 maxlength=20 #newPassword="ngModel"  autocomplete="off" autofocus required>
        <span class="bar"></span>
        <label [ngClass]="[updateStyle ? 'customLabel' : '']">{{'global.form.newpassword' | translate}}</label>
        <p></p>
        <div *ngIf="newPassword.errors && (newPassword.dirty || newPassword.touched)">
          <p class="passwordError" *ngIf="newPassword.errors.pattern">{{'global.form.passwordvalidation' | translate}}</p>

        </div>
      </div>
    </div>
    <div class="col-md-4 noPaddingMd-12">
      <div class="login-form-group pmi_form_group">
        <input type="password"  id="confirmPassword" (change)="updateLabelConfirmPasswordlabel()"
               name="confirmPassword" [(ngModel)]="confirmPasswordVal"
               pattern="^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
               minlength=4 maxlength=20 #confirmPassword="ngModel"  autocomplete="off" autofocus required>
        <span class="bar"></span>
        <label [ngClass]="[updateLabel ? 'customLabel' : '']">{{'global.form.confirmpassword' | translate}}</label>
        <p></p>
        <div *ngIf="confirmPassword.errors && (confirmPassword.dirty || confirmPassword.touched)">
          <p class="passwordError" *ngIf="confirmPassword.errors.pattern">{{'global.form.passwordvalidation' | translate}}</p>
        </div>
      </div>
    </div>

    <div class="col-md-12"></div>
    <div class="col-md-4 noPaddingMd-12">

    </div>
    <div class="col-md-4 btnDiv">
      <button type="submit"  class="btn btn-primary passBtn" [disabled]="!passwordForm.form.valid">{{'password.form.button' | translate}}</button>
    </div>
    </form>
    <div class="col-md-4 noPaddingMd-12">

    </div>
  </div>
  </div>
